import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import './Calendar.scss';
import { useScreenResizing } from 'hooks/UI/useScreenResizing';
import { setLocation } from 'redux/LocationSearch/location.actions';
import { setPlaceLocation } from 'redux/LocationSearch/location.actions';
import { useDispatch, useSelector } from 'react-redux';
import SelectBed from '../Assents/image/SelectBed.svg';
import CalendarMobile from './CalendarMobile';
import { clearState } from 'redux/bedRooms/bedRooms.actions';
import { TravelCheckbox } from 'components/TravelCheckbox';
import { TravelWithAnimalsCheckbox } from 'components/TravelWithAnimalsCheckbox';
import { useTranslation } from 'react-i18next';
import CalendarDesktop from './CalendarDesktop';
const Calendar = ({ suggest, setSuggest, onSubmit }) => {
    const viewPort = useScreenResizing();
    const isDesktop = viewPort.width > 1199;
    const isMobile = viewPort.width > 319 && viewPort.width < 768;
    const dispatch = useDispatch();
    const placeLocation = useSelector(state => state.searchLocationReducer.placeLocation);
    const [isLocationMobileOpen, setIsLocationMobileOpen] = useState(false);
    const [isBedMobileOpen, setIsBedMobileOpen] = useState(false);
    const [isDateMobileOpen, setIsDateMobileOpen] = useState(false);
    const [icon, setIcon] = useState(false);
    const [open, setOpen] = useState(false);
    const [hidden, setHidden] = useState(false);
    const { t } = useTranslation('Calendar');
    const [selectedLocation, setSelectedLocation] = useState('');
    const [isLocationListOpen, setIsLocationListOpen] = useState(false);
    const [isDateSectionActive, setIsDateSectionActive] = useState(false);
    const [checkedDot, setChecketDot] = useState(false);
    const [isAnimalSelected, setIsAnimalSelected] = useState(false);
    const [sugAmount, setSugAmount] = useState(false);
    const bedSectionRef = useRef(null);
    const dateSectionRef = useRef(null);
    const btnNextClickRef = useRef(null);
    const locationRef = useRef('');
    const [calendarValue, setCalendarValue] = useState('');
    // showBedRoom
    const [oneBedRoom, setOneBedRoom] = useState(false);
    const [twoBedRoom, setTwoBedRoom] = useState(false);
    const [threeBedRoom, setThreeBedRoom] = useState(false);
    const [fourBedRoom, setFourBedRoom] = useState(false);
    const [gbvcss, setGbvcss] = useState(false);
    const [unshownGbvcss, setUnshownGbvcss] = useState(false);
    //
    const [openOneBedRoom, setOpenOneBedRoom] = useState(false);
    const [showOneBedroomAttetion, setShowOneBedroomAttetion] = useState(false);
    const [openTwoBedRoom, setOpenTwoBedRoom] = useState(false);
    const [openGbvcss, setOpenGbvcss] = useState(false);
    const [showGbvcssAttetion, setShowGbvcssAttetion] = useState(false);
    const [openThreeBedRoom, setOpenThreeBedRoom] = useState(false);
    const [openFourBedRoom, setOpenFourBedRoom] = useState(false);
    const [isBedroomSectionActive, setIsBedroomSectionActive] = useState(false);
    const [selectBedRoom, setSelectBedRoom] = useState(true);
    const [sugLocation, setSugLocation] = useState({
        sugLocSel: 'Выберите локацию',
        sugLocSelected: 'Локация выбрана',
        sugLocStatus: selectedLocation || (placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.changeableLocation) || (placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.location) ? true : false,
    });
    const [sugDate, setSugDate] = useState({
        sugDateSel: 'Выберите даты',
        sugDateSelected: 'Даты выбраны',
        sugDateStatus: false,
    });
    const [sugBed, setSugBed] = useState({
        sugBedSel: 'Выберите спальни',
        sugBedSelected: 'Спальни выбраны',
        sugBedStatus: false,
        sugClickBedStatus: false,
    });
    const [isBtnNextClick, setIsBtnNextClick] = useState(false);
    const bedRoomReducer = useSelector(state => state.bedRoomReducer);
    const [isWorkTraveling, setIsWorkTraveling] = useState(false);
    const [amountOfClicksInCheckbox, setAmountOfClicksInCheckbox] = useState(0);
    const handleBtnSuggest = value => {
        switch (value) {
            case 'location':
                setIsLocationMobileOpen(true);
                break;
            case 'bed':
                setIsBedMobileOpen(true);
                break;
            case 'date':
                setIsDateMobileOpen(true);
                break;
            default:
                setIsLocationMobileOpen(true);
                break;
        }
        setSuggest(true);
    };
    let allBoolean = [
        !openOneBedRoom,
        !openTwoBedRoom,
        !openThreeBedRoom,
        !openFourBedRoom,
        !openFourBedRoom,
        !openGbvcss,
        !open,
        sugDate.sugDateStatus,
        sugBed.sugBedStatus,
        sugBed.sugClickBedStatus,
        sugLocation.sugLocStatus,
    ];
    let checkBool = allBoolean.every(el => el);
    const onHandleBottomBtnClick = e => {
        e.preventDefault();
        setIsBtnNextClick(true);
        console.log('onHandleBottomBtnClick');
        console.log(sugBed, sugDate, sugLocation);
        if (!openOneBedRoom && !openTwoBedRoom && !openThreeBedRoom && !openFourBedRoom && !openGbvcss) {
            if (!sugLocation.sugLocStatus) {
                setIsLocationListOpen(true);
                return;
            }
            if ((sugLocation.sugLocStatus && !sugBed.sugBedStatus) || !sugBed.sugClickBedStatus) {
                setIsBedroomSectionActive(true);
                return;
            }
            if (sugLocation.sugLocStatus && sugBed.sugBedStatus && sugBed.sugClickBedStatus && !sugDate.sugDateStatus) {
                setIsDateSectionActive(true);
                return;
            }
        }
        if (!sugBed.sugBedStatus || !sugBed.sugClickBedStatus) {
            if (openOneBedRoom) {
                setShowOneBedroomAttetion(true);
                return;
            }
            if (openGbvcss && gbvcss) {
                setShowGbvcssAttetion(true);
                return;
            }
        }
        if (checkBool) {
            setSugAmount(true);
            return;
        }
    };
    const closeSuggest = () => {
        setSuggest(false);
        setSugAmount(false);
        dispatch(clearState());
        setSelectBedRoom(true);
        setOneBedRoom(false);
        setTwoBedRoom(false);
        setThreeBedRoom(false);
        setFourBedRoom(false);
        setGbvcss(false);
        setOpenOneBedRoom(false);
        setShowOneBedroomAttetion(false);
        setOpenTwoBedRoom(false);
        setOpenGbvcss(false);
        setUnshownGbvcss(false);
        setShowGbvcssAttetion(false);
        setOpenThreeBedRoom(false);
        setOpenFourBedRoom(false);
        setSelectedLocation('');
        setIsLocationListOpen(false);
        setIsBedroomSectionActive(false);
        setIsDateSectionActive(false);
        locationRef.current = '';
        setChecketDot(false);
        setIsWorkTraveling(false);
        setAmountOfClicksInCheckbox(0);
        setIsAnimalSelected(false);
        dispatch(setLocation([]));
        dispatch(setPlaceLocation({}));
        setIsBedMobileOpen(false);
        setIsDateMobileOpen(false);
        setIsLocationMobileOpen(false);
    };
    useEffect(() => {
        if (placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.changeableLocation) {
            setSelectedLocation(placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.changeableLocation);
        }
        else {
            setSelectedLocation('');
        }
        if ((placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.location) || (placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.changeableLocation)) {
            locationRef.current = (placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.location) || (placeLocation === null || placeLocation === void 0 ? void 0 : placeLocation.changeableLocation);
            if (isMobile) {
                setSuggest(true);
            }
        }
    }, [placeLocation]);
    useEffect(() => {
        const sugDateEl = document.getElementById('sugDate');
        if (!sugDateEl) {
            return;
        }
        if (sugDate.sugDateStatus) {
            sugDateEl.classList.remove('reverse-animation');
            sugDateEl.classList.add('animate-color');
        }
        else {
            sugDateEl.classList.remove('animate-color');
            sugDateEl.classList.add('reverse-animation');
        }
    }, [sugDate.sugDateStatus]);
    useEffect(() => {
        const sugLocationEl = document.getElementById('sugLocation');
        if (!sugLocationEl) {
            return;
        }
        if (sugLocation.sugLocStatus) {
            sugLocationEl.classList.remove('reverse-animation');
            sugLocationEl.classList.add('animate-color');
        }
        else {
            sugLocationEl.classList.remove('animate-color');
            sugLocationEl.classList.add('reverse-animation');
        }
    }, [sugLocation.sugLocStatus]);
    useEffect(() => {
        const sugBedEl = document.getElementById('sugBed');
        if (!sugBedEl) {
            return;
        }
        if (sugBed.sugClickBedStatus) {
            sugBedEl.classList.remove('reverse-animation');
            sugBedEl.classList.add('animate-color');
        }
        else {
            sugBedEl.classList.remove('animate-color');
            sugBedEl.classList.add('reverse-animation');
        }
    }, [sugBed.sugClickBedStatus]);
    const changeSugDate = useCallback(() => {
        if (calendarValue && Array.isArray(calendarValue)) {
            setSugDate(prev => {
                return Object.assign(Object.assign({}, prev), { sugDateStatus: true });
            });
            return;
        }
        setSugDate(prev => {
            return Object.assign(Object.assign({}, prev), { sugDateStatus: false });
        });
    }, [calendarValue]);
    const changeSugBed = useCallback(() => {
        let arrBed = Object.values(bedRoomReducer);
        const containBed = arrBed.some(element => element > 0);
        if (containBed) {
            setSugBed(prev => {
                return Object.assign(Object.assign({}, prev), { sugBedStatus: true });
            });
            return containBed;
        }
        setSugBed(prev => {
            return Object.assign(Object.assign({}, prev), { sugBedStatus: false });
        });
        setSugBed(prev => {
            return Object.assign(Object.assign({}, prev), { sugClickBedStatus: false });
        });
    }, [bedRoomReducer]);
    const changeSugLocation = useCallback(() => {
        if (locationRef.current !== '') {
            setSugLocation(prev => {
                return Object.assign(Object.assign({}, prev), { sugLocStatus: true });
            });
            return;
        }
        setSugLocation(prev => {
            return Object.assign(Object.assign({}, prev), { sugLocStatus: false });
        });
    }, []);
    useEffect(() => {
        const checkContainBed = changeSugBed();
        if (checkContainBed) {
            setSugBed(prev => {
                return Object.assign(Object.assign({}, prev), { sugClickBedStatus: true });
            });
        }
    }, []);
    useEffect(() => {
        changeSugDate();
        changeSugBed();
        changeSugLocation();
    }, [suggest, bedRoomReducer, selectedLocation, calendarValue]);
    const handleSelectLocation = location => {
        setSelectedLocation(location);
        setOpen(!open);
        locationRef.current = location;
    };
    const handleSugLocStatusChange = newStatus => {
        if (!newStatus) {
            locationRef.current = '';
        }
        setSugLocation(prevSugLocation => (Object.assign(Object.assign({}, prevSugLocation), { sugLocStatus: newStatus })));
    };
    const handleLocationChange = value => {
        handleSelectLocation(value);
        setSugLocation(prevLocation => (Object.assign(Object.assign({}, prevLocation), { sugLocSelected: value })));
    };
    const backToSelectRoom = () => {
        dispatch(clearState());
        setSelectBedRoom(true);
        setOneBedRoom(false);
        setTwoBedRoom(false);
        setThreeBedRoom(false);
        setFourBedRoom(false);
        setGbvcss(false);
        setOpenOneBedRoom(false);
        setShowOneBedroomAttetion(false);
        setOpenTwoBedRoom(false);
        setOpenGbvcss(false);
        setShowGbvcssAttetion(false);
        setOpenThreeBedRoom(false);
        setOpenFourBedRoom(false);
    };
    const clickOnIconOneBedRoom = () => {
        setOpenOneBedRoom(true);
    };
    const readyBtnOneBedRoom = () => {
        setOpenOneBedRoom(false);
        if (sugBed.sugBedStatus) {
            setSugBed(prev => {
                return Object.assign(Object.assign({}, prev), { sugClickBedStatus: true });
            });
        }
    };
    const clickOnIconTwoBedRoom = () => {
        setOpenTwoBedRoom(true);
    };
    const readyBtnTwoBedRoom = () => {
        setOpenTwoBedRoom(false);
        if (sugBed.sugBedStatus) {
            setSugBed(prev => {
                return Object.assign(Object.assign({}, prev), { sugClickBedStatus: true });
            });
        }
    };
    const clickOnIconThreeBedRoom = () => {
        setOpenThreeBedRoom(true);
    };
    const readyBtnThreeBedRoom = () => {
        setOpenThreeBedRoom(false);
        if (sugBed.sugBedStatus) {
            setSugBed(prev => {
                return Object.assign(Object.assign({}, prev), { sugClickBedStatus: true });
            });
        }
    };
    const clickOnIconGbvcss = () => {
        setOpenGbvcss(true);
    };
    const readyBtnGbvcss = () => {
        setOpenGbvcss(false);
        if (sugBed.sugBedStatus) {
            setSugBed(prev => {
                return Object.assign(Object.assign({}, prev), { sugClickBedStatus: true });
            });
        }
    };
    const clickOnIconFourBedRoom = () => {
        setOpenFourBedRoom(true);
    };
    const readyBtnFourBedRoom = () => {
        setOpenFourBedRoom(false);
        if (sugBed.sugBedStatus) {
            setSugBed(prev => {
                return Object.assign(Object.assign({}, prev), { sugClickBedStatus: true });
            });
        }
    };
    useEffect(() => {
        const checkClose = e => {
            const calendarBlock = document.getElementById('calendarBlock');
            const locationBlock = document.getElementById('locationId');
            const checkBoxWork = document.getElementById('checkbox_work');
            // const checkAnimal = document.getElementById('openChecked_window');
            const checkAnimalInput = document.getElementById('block_checkbox_animal');
            const clickCalendar = e.composedPath().includes(calendarBlock);
            const clickloc = e.composedPath().includes(locationBlock);
            // const clickAnim = e.composedPath().includes(checkAnimal);
            const clickCheckWork = e.composedPath().includes(checkBoxWork);
            const clickAnimInput = e.composedPath().includes(checkAnimalInput);
            if (clickCalendar || clickAnimInput || clickCheckWork) {
                setSuggest(true);
            }
            if (hidden && icon) {
                setHidden(false);
                setIcon(false);
            }
            else if (!clickloc && open) {
                setOpen(false);
            }
            if (clickCalendar) {
                setAmountOfClicksInCheckbox(prev => prev + 1);
            }
        };
        document.addEventListener('click', checkClose);
        return () => {
            document.removeEventListener('click', checkClose);
        };
    }, [hidden, icon, open, setSuggest]);
    const showOneBedRoom = () => {
        setSelectBedRoom(false);
        setOneBedRoom(true);
        setOpenOneBedRoom(true);
    };
    const showTwoBedRoom = () => {
        setSelectBedRoom(false);
        setTwoBedRoom(true);
        setOpenTwoBedRoom(true);
    };
    const showThreeBedRoom = () => {
        setSelectBedRoom(false);
        setThreeBedRoom(true);
        setOpenThreeBedRoom(true);
    };
    const showFourBedRoom = () => {
        setSelectBedRoom(false);
        setFourBedRoom(true);
        setOpenFourBedRoom(true);
    };
    const showGbvcss = () => {
        if (checkedDot) {
            setUnshownGbvcss(true);
            return;
        }
        setUnshownGbvcss(false);
        setSelectBedRoom(false);
        setGbvcss(true);
        setOpenGbvcss(true);
    };
    const showSelectBed = () => {
        setIcon(!icon);
        setHidden(!hidden);
    };
    useEffect(() => {
        setSugLocation(prev => {
            return Object.assign(Object.assign({}, prev), { sugLocSel: t('defaultLocation'), sugLocSelected: t('locationSelected') });
        });
        setSugDate(prev => {
            return Object.assign(Object.assign({}, prev), { sugDateSel: t('selectDates'), sugDateSelected: t('datesSelected'), sugDateDefaultMobile: t('bookingDates') });
        });
        setSugBed(prev => {
            return Object.assign(Object.assign({}, prev), { sugBedSel: t('selectBedrooms'), sugBedSelected: t('bedroomsSelected'), sugBedDefaultMobile: t('bedAmount') });
        });
    }, [t]);
    return (_jsxs("div", Object.assign({ className: 'calendar__section__main' }, { children: [isMobile && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "mobile_calendar_wrapper" }, { children: [_jsx("button", Object.assign({ className: "btn_location", type: "button", onClick: () => {
                                    handleBtnSuggest('location');
                                } }, { children: sugLocation.sugLocSel })), _jsxs("div", Object.assign({ className: "calendar_bottom_btn_wrapper" }, { children: [_jsxs("div", Object.assign({ className: "calendar_mobile_btn_wrapper" }, { children: [_jsx("svg", Object.assign({ className: "calendar_mobile_dateicon_wrapper" }, { children: _jsx("use", { href: `${SelectBed}#icon_calendar_mobile` }) })), _jsx("button", Object.assign({ className: `btn_date`, type: "button", onClick: () => {
                                                    handleBtnSuggest('date');
                                                } }, { children: sugDate.sugDateDefaultMobile }))] })), _jsx("svg", Object.assign({ className: "mobile_calendar_dote", width: "2", height: "2", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("circle", { cx: "1", cy: "1", r: "1", fill: "rgba(76, 76, 76, 1);" }) })), _jsxs("div", Object.assign({ className: "calendar_mobile_btn_wrapper" }, { children: [_jsx("svg", Object.assign({ className: "calendar_mobile_bedicon_wrapper" }, { children: _jsx("use", { href: `${SelectBed}#icon_bed_single` }) })), _jsx("button", Object.assign({ className: `btn_bed`, type: "button", onClick: () => {
                                                    handleBtnSuggest('bed');
                                                } }, { children: sugBed.sugBedDefaultMobile }))] }))] }))] })), suggest && (_jsx("div", Object.assign({ className: suggest ? 'block__suggest-modal' : null }, { children: _jsxs(CalendarMobile, Object.assign({ closeSuggest: closeSuggest, sugAmount: sugAmount, isDesktop: isDesktop, suggest: suggest, calendarValue: calendarValue, setSugAmount: setSugAmount, onSubmit: onSubmit, setSuggest: setSuggest, setSugDate: setSugDate, setSelectBedRoom: setSelectBedRoom, setOneBedRoom: setOneBedRoom, setTwoBedRoom: setTwoBedRoom, setThreeBedRoom: setThreeBedRoom, setFourBedRoom: setFourBedRoom, setGbvcss: setGbvcss, setOpenOneBedRoom: setOpenOneBedRoom, setOpenTwoBedRoom: setOpenTwoBedRoom, setOpenGbvcss: setOpenGbvcss, setOpenThreeBedRoom: setOpenThreeBedRoom, setOpenFourBedRoom: setOpenFourBedRoom, setSelectedLocation: setSelectedLocation, setChecketDot: setChecketDot, setIsWorkTraveling: setIsWorkTraveling, locationRef: locationRef, dateSectionRef: dateSectionRef, sugDate: sugDate, isDateSectionActive: isDateSectionActive, sugLocation: sugLocation, sugBed: sugBed, setIsLocationListOpen: setIsLocationListOpen, isLocationListOpen: isLocationListOpen, handleSelectLocation: handleSelectLocation, selectedLocation: selectedLocation, placeLocation: placeLocation, handleSugLocStatusChange: handleSugLocStatusChange, handleLocationChange: handleLocationChange, selectBedRoom: selectBedRoom, oneBedRoom: oneBedRoom, backToSelectRoom: backToSelectRoom, openOneBedRoom: openOneBedRoom, clickOnIconOneBedRoom: clickOnIconOneBedRoom, twoBedRoom: twoBedRoom, openTwoBedRoom: openTwoBedRoom, clickOnIconTwoBedRoom: clickOnIconTwoBedRoom, threeBedRoom: threeBedRoom, openThreeBedRoom: openThreeBedRoom, clickOnIconThreeBedRoom: clickOnIconThreeBedRoom, gbvcss: gbvcss, openGbvcss: openGbvcss, clickOnIconGbvcss: clickOnIconGbvcss, fourBedRoom: fourBedRoom, openFourBedRoom: openFourBedRoom, clickOnIconFourBedRoom: clickOnIconFourBedRoom, readyBtnOneBedRoom: readyBtnOneBedRoom, showOneBedroomAttetion: showOneBedroomAttetion, isBtnNextClick: isBtnNextClick, setShowOneBedroomAttetion: setShowOneBedroomAttetion, readyBtnTwoBedRoom: readyBtnTwoBedRoom, readyBtnThreeBedRoom: readyBtnThreeBedRoom, readyBtnFourBedRoom: readyBtnFourBedRoom, readyBtnGbvcss: readyBtnGbvcss, showGbvcssAttetion: showGbvcssAttetion, setShowGbvcssAttetion: setShowGbvcssAttetion, bedSectionRef: bedSectionRef, hidden: hidden, isBedroomSectionActive: isBedroomSectionActive, setCalendarValue: setCalendarValue, isWorkTraveling: isWorkTraveling, setAmountOfClicksInCheckbox: setAmountOfClicksInCheckbox, amountOfClicksInCheckbox: amountOfClicksInCheckbox, checkedDot: checkedDot, setIsAnimalSelected: setIsAnimalSelected, isAnimalSelected: isAnimalSelected, btnNextClickRef: btnNextClickRef, checkBool: checkBool, onHandleBottomBtnClick: onHandleBottomBtnClick, showOneBedRoom: showOneBedRoom, showTwoBedRoom: showTwoBedRoom, showGbvcss: showGbvcss, showThreeBedRoom: showThreeBedRoom, showFourBedRoom: showFourBedRoom, showSelectBed: showSelectBed, icon: icon, setUnshownGbvcss: setUnshownGbvcss, setIsBedroomSectionActive: setIsBedroomSectionActive, selectedValue: selectedLocation, locationOpen: isLocationMobileOpen, dateOpen: isDateMobileOpen, bedOpen: isBedMobileOpen }, { children: [_jsx(TravelCheckbox, { onChangeIsWorkTraveling: value => {
                                        setIsWorkTraveling(value);
                                    }, isWorkTraveling: isWorkTraveling, setAmountOfClicksInCheckbox: () => {
                                        setAmountOfClicksInCheckbox(prev => prev + 1);
                                    } }), _jsx(TravelWithAnimalsCheckbox, { gbvcss: gbvcss, setAmountOfClicksInCheckbox: () => {
                                        setAmountOfClicksInCheckbox(prev => prev + 1);
                                    }, amountOfClicksInCheckbox: amountOfClicksInCheckbox, checkedDot: checkedDot, setChecketDot: value => {
                                        setChecketDot(value);
                                    }, onChangeIsAnimalSelected: setIsAnimalSelected, animalSelected: isAnimalSelected })] })) }))), !sugAmount && suggest && (_jsx("button", Object.assign({ ref: btnNextClickRef, type: "button", className: !checkBool ? 'bottom_btn_disabled' : 'bottom_btn', onClick: onHandleBottomBtnClick }, { children: t('next') })))] })), !isMobile && (_jsx(CalendarDesktop, { closeSuggest: closeSuggest, sugAmount: sugAmount, isDesktop: isDesktop, suggest: suggest, calendarValue: calendarValue, setSugAmount: setSugAmount, onSubmit: onSubmit, setSuggest: setSuggest, setSelectBedRoom: setSelectBedRoom, setOneBedRoom: setOneBedRoom, setTwoBedRoom: setTwoBedRoom, setThreeBedRoom: setThreeBedRoom, setFourBedRoom: setFourBedRoom, setGbvcss: setGbvcss, setOpenOneBedRoom: setOpenOneBedRoom, setOpenTwoBedRoom: setOpenTwoBedRoom, setOpenGbvcss: setOpenGbvcss, setOpenThreeBedRoom: setOpenThreeBedRoom, setOpenFourBedRoom: setOpenFourBedRoom, setSelectedLocation: setSelectedLocation, setChecketDot: setChecketDot, setIsWorkTraveling: setIsWorkTraveling, locationRef: locationRef, dateSectionRef: dateSectionRef, sugDate: sugDate, isDateSectionActive: isDateSectionActive, sugLocation: sugLocation, sugBed: sugBed, setIsLocationListOpen: setIsLocationListOpen, isLocationListOpen: isLocationListOpen, handleSelectLocation: handleSelectLocation, selectedLocation: selectedLocation, placeLocation: placeLocation, handleSugLocStatusChange: handleSugLocStatusChange, selectBedRoom: selectBedRoom, oneBedRoom: oneBedRoom, backToSelectRoom: backToSelectRoom, openOneBedRoom: openOneBedRoom, clickOnIconOneBedRoom: clickOnIconOneBedRoom, twoBedRoom: twoBedRoom, openTwoBedRoom: openTwoBedRoom, clickOnIconTwoBedRoom: clickOnIconTwoBedRoom, threeBedRoom: threeBedRoom, openThreeBedRoom: openThreeBedRoom, clickOnIconThreeBedRoom: clickOnIconThreeBedRoom, gbvcss: gbvcss, openGbvcss: openGbvcss, clickOnIconGbvcss: clickOnIconGbvcss, fourBedRoom: fourBedRoom, openFourBedRoom: openFourBedRoom, clickOnIconFourBedRoom: clickOnIconFourBedRoom, readyBtnOneBedRoom: readyBtnOneBedRoom, showOneBedroomAttetion: showOneBedroomAttetion, isBtnNextClick: isBtnNextClick, setShowOneBedroomAttetion: setShowOneBedroomAttetion, readyBtnTwoBedRoom: readyBtnTwoBedRoom, readyBtnThreeBedRoom: readyBtnThreeBedRoom, readyBtnFourBedRoom: readyBtnFourBedRoom, readyBtnGbvcss: readyBtnGbvcss, showGbvcssAttetion: showGbvcssAttetion, setShowGbvcssAttetion: setShowGbvcssAttetion, bedSectionRef: bedSectionRef, hidden: hidden, isBedroomSectionActive: isBedroomSectionActive, setCalendarValue: setCalendarValue, isWorkTraveling: isWorkTraveling, setAmountOfClicksInCheckbox: setAmountOfClicksInCheckbox, amountOfClicksInCheckbox: amountOfClicksInCheckbox, checkedDot: checkedDot, setIsAnimalSelected: setIsAnimalSelected, isAnimalSelected: isAnimalSelected, btnNextClickRef: btnNextClickRef, checkBool: checkBool, onHandleBottomBtnClick: onHandleBottomBtnClick, showOneBedRoom: showOneBedRoom, showTwoBedRoom: showTwoBedRoom, showGbvcss: showGbvcss, showThreeBedRoom: showThreeBedRoom, showFourBedRoom: showFourBedRoom, showSelectBed: showSelectBed, icon: icon }))] })));
};
export default Calendar;
